import { render, staticRenderFns } from "./linkwil-camera.vue?vue&type=template&id=29e88fa2&scoped=true&"
import script from "./linkwil-camera.js?vue&type=script&lang=js&"
export * from "./linkwil-camera.js?vue&type=script&lang=js&"
import style0 from "./linkwil-camera.css?vue&type=style&index=0&id=29e88fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e88fa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
